<div class="h-full px-8">
  <div class="mx-auto logo-sidebar my-3">
    <img alt="logo tg mob" src="images/logo/logo-white-2.png" />
  </div>
  <div class="menu-sidebar overflow-auto">
    @for (menu of listMenu; track menu.label) {
      @if (menu.type == 'title') {
        <div
          class="text-white text-base menu-item"
          (click)="navigateTo(menu.route!)"
          [routerLink]="menu.route!"
          routerLinkActive="active-link"
        >
          {{ menu.label }}
        </div>
      } @else if (menu.type == 'subTitle' && menu.children!.length > 0) {
        <div
          class="text-white text-base submenu"
          (click)="menuToggle(menu.label)"
        >
          {{ menu.label }}
        </div>
        <div
          class="submenu-items"
          [ngClass]="menuSelected == menu.label ? 'expanded' : ''"
        >
          @for (subItem of menu.children; track subItem.label) {
            <div
              class="text-white text-base submenu-item"
              (click)="navigateTo(subItem.route!)"
              [routerLink]="subItem.route!"
              routerLinkActive="active-link"
            >
              {{ subItem.label }}
            </div>
          }
        </div>
      }
    }
  </div>
</div>
